import React from 'react';

interface ContextValue
  extends Readonly<{
    shouldEmulateEricssonFrame: () => boolean;
  }> {}

const Context = React.createContext<ContextValue>({
  shouldEmulateEricssonFrame: () => {
    throw new Error('DeveloperContextProvider not found!');
  },
});

interface DeveloperContextProviderProps
  extends Readonly<{
    shouldEmulateEricssonFrame: boolean;
    children?: React.ReactNode;
  }> {}

export const DeveloperContextProvider = React.memo<DeveloperContextProviderProps>((props) => {
  const { shouldEmulateEricssonFrame, children } = props;

  const ShouldEmulateEricssonFrameCallback = React.useCallback<() => boolean>(() => shouldEmulateEricssonFrame, [
    shouldEmulateEricssonFrame,
  ]);

  const ContextValue = React.useMemo(() => {
    const contextValue: ContextValue = {
      shouldEmulateEricssonFrame: ShouldEmulateEricssonFrameCallback,
    };

    return contextValue;
  }, [ShouldEmulateEricssonFrameCallback]);

  return <Context.Provider value={ContextValue}>{children}</Context.Provider>;
});

export const useDeveloperContext = () => React.useContext<ContextValue>(Context);
